import get from 'lodash/get';
import { push } from 'redux-little-router';
import {loadModelPath} from "~/actions/ui_actions";
import lexModelPathName from "~/navigation/helpers/lexModelPathName";
import isPathValid from "~/navigation/helpers/isPathValid";
import identify from "~/identify";
import {changeAppPage} from "~/actions/actions";

const createModelTreeHelper = ({store, action}) => {
    let data = action.payload,
        dispatch = store.dispatch,
        noConfirm = get(action, 'payload.options.noConfirm', false);

    const ensurePathModelTree = () => {
        let path = lexModelPathName(data.pathname);

        let state = store.getState(),
            valid = isPathValid(path, state.availableModels);
        
        if(!valid) {
            dispatch(changeAppPage(identify.APP_PAGE_NOTFOUND));
            return;    
        }
        
        let changeRootModel = get(data, 'options.forceChangeRootModel', false);
        dispatch(loadModelPath(path, changeRootModel, noConfirm));
    };

    return {
        ensurePathModelTree,
    };
};

export default createModelTreeHelper;